<template>
  <div class="modal-send-email">
    <ElementModal @close="closeModal">
      <h2 slot="header">Copy/paste the following contacts in your mail client</h2>
      <div slot="body">
        <form>
          <!-- Separator -->
          <ElementFormGroup :label="$t(`message.modal.sendEmail.separator`)">
            <div class="modal-send-email__select">
              <select name="separator-modifier" id="separator-modifier" v-model="separator">
                <option value=";">;</option>
                <option value=",">,</option>
              </select>
            </div>
          </ElementFormGroup>

          <!-- TO -->
          <ElementFormGroup :label="$t(`message.modal.sendEmail.sendTo`)">
            <textarea ref="textareaTo" v-model="formattedEmailToList" />
          </ElementFormGroup>
          <BaseButton color="primary" @click.native="copyToClipBoard('textareaTo', formattedEmailToList)">
            {{ $t(`message.modal.sendEmail.sendToBtn`) }}
          </BaseButton>

          <!-- Cc -->
          <ElementFormGroup :label="$t(`message.modal.sendEmail.sendCc`)">
            <textarea ref="textareaCc" v-model="formattedEmailCcList" />
          </ElementFormGroup>
          <BaseButton color="primary" @click.native="copyToClipBoard('textareaCc', formattedEmailCcList)">
            {{ $t(`message.modal.sendEmail.sendCcBtn`) }}
          </BaseButton>
        </form>
      </div>
    </ElementModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ElementModal from '@elements/ElementModal'
import ElementFormGroup from '@elements/ElementFormGroup'
import BaseButton from '@base/BaseButton'
export default {
  name: 'TheModalSendEmail',
  components: {
    ElementModal,
    ElementFormGroup,
    BaseButton
  },
  data () {
    return {
      splitAt: 2,
      toList: [],
      ccList: []
    }
  },
  computed: {
    ...mapGetters({
      selected: 'users/getSelected',
      emailSeparator: 'users/getEmailSeparator',
      emailToList: 'users/getEmailToList',
      emailCcList: 'users/getEmailCcList'
    }),
    separator: {
      get () {
        return this.emailSeparator
      },
      set (value) {
        this.updateEmailSeparator(value)
      }
    },
    formattedEmailToList () {
      return this.emailToList.join(this.separator)
    },
    formattedEmailCcList () {
      return this.emailCcList.join(this.separator)
    }
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName',
      updateEmailSeparator: 'users/updateEmailSeparator'
    }),
    closeModal () {
      this.updateName('')
    },
    copyToClipBoard (textarea, value) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(textarea, value)
        return
      }
      navigator.clipboard.writeText(value).then(() => {
        console.log('Async: Copying to clipboard was successful!')
      }, (err) => {
        console.error('Async: Could not copy text: ', err)
      })
    },
    fallbackCopyTextToClipboard (textArea, value) {
      this.$refs[textArea].focus()
      this.$refs[textArea].select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
    }
  }
}
</script>

<style lang="scss">
  .modal-send-email{

    .modal{
      &__header{
        h2{
          padding-right: 2rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid colors('border');
        }
      }
      &__container{
        width: 100%;
        max-width: 90rem;
      }
    }

    .form-group{
      margin-top: .5rem;
      margin-bottom: 0;

      &:first-of-type{
        margin-top: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        > * {
          flex: 0 1 auto;
        }

        label{
          font-size: 1.4rem;
        }
      }

      label{
        margin-bottom: 0;
        font-size: 2.4rem;
        font-weight: font-weights('medium');
      }
    }

    .form-textarea{
      textarea{
        background-color: colors('foreground');
        border-color: colors('border');
      }
    }

    .button{
      margin-bottom: 1rem;
    }

    &__select{
      @include custom-select;
      select{
        padding-top: .5rem;
        padding-bottom: .5rem;
      }
    }
  }
</style>
